import { Button, Card, Input, List, Modal, Progress } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from './WorkOrderSerialNumber.redux';
import React from 'react';

const WorkOrderSNAllocationModal = () => {
	const dispatch            = useDispatch(),
		  docNum              = useSelector(state => state.workOrderReference.selectedWODocNum),
		  plannedQty          = useSelector(state => state.workOrderReference.workOrderHeader.PlannedQty),
		  visible             = useSelector(state => state.workOrderSerialNum.SNAllocationModalOpen),
		  allocatingSNs       = useSelector(state => state.workOrderSerialNum.allocatingSNs),
		  allocatingSNPercent = useSelector(state => state.workOrderSerialNum.allocatingSNPercent),
		  remainingSNList     = useSelector(state => state.workOrderSerialNum.remainingSNList),
		  allocatedSNList     = useSelector(state => state.workOrderSerialNum.allocatedSNList);

	
	const handleClose = () => {
		dispatch(actions.setState({ SNAllocationModalOpen: false }));
	}

    return (
		<Modal
			open={visible}
			onCancel={() => handleClose()}
			maskClosable={false}
			closable={!allocatingSNs}
			width={1000}
			bodyStyle={{ overflowY: 'auto', maxHeight: 'calc(100vh - 250px)' }}
			footer={[
				<Button key="sn_allocate_modal_close" disabled={allocatingSNs} onClick={() => handleClose()}>Close</Button>,
			]}
		>
			<Card className="ts-full-width ts_margin_top" title={`Allocate Serial Numbers to Work Order ${docNum}`}>

				<p>This work order requires {plannedQty} serial numbers in total and has {allocatedSNList.length}. Fill in any missing serial numbers and save them to the work order.</p>
				
				<List
					header="Previously Allocated"
					bordered
					itemLayout="vertical"
					dataSource={allocatedSNList}
					renderItem={(item, index) => (
						<List.Item key={index}>
							{item.U_TS_Allocated_Serial}
						</List.Item>
					)}
				/>

				{
					(remainingSNList.length > 0) &&
					<List
						itemLayout="vertical"
						dataSource={remainingSNList}
						
						renderItem={(item, index) => (
							<List.Item key={index+'_new'}>
								<Input 
									size="large"
									placeholder="Serial Number"
									defaultValue={item.U_TS_Allocated_Serial}
									onBlur={(event) => {
										const value = event.target.value;
										dispatch(actions.updateRemainingSNList(value, index))
									}}
								/>
							</List.Item>
						)}
					/>
				}

				{
					allocatingSNs &&
					<div>
						<p>Serial numbers are being assigned to route stages...please wait</p>
						<Progress percent={allocatingSNPercent} showInfo={false} strokeColor='#12082c' />
					</div>
				}
				
				<div className="ts-full-width ts-margin-top">
					<Button 
						className='ts_margin_left'
						size='large' 
						type='primary'
						disabled={allocatedSNList.length === parseInt(plannedQty) || allocatingSNs}
						onClick={() => {
							dispatch(actions.allocateNewSerialNumbers());
						}}
					>
						Save New Serial Numbers to Work Order
					</Button>
				</div>

				
			</Card>
		</Modal>
    );
};

export default WorkOrderSNAllocationModal;
